import { Link } from 'react-router-dom';

export function NotFound() {
  return (
    <section className="not-found">
      <div>
        <span className="eyebrow">404 · Route not found</span>
        <h1>This road is not on the map yet.</h1>
        <p>Return to the Sawwari launch experience and choose another route.</p>
        <Link className="button button--primary" to="/">Back to home</Link>
      </div>
    </section>
  );
}
